import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

// Import Api files
import {
  addPersonnelApi,
  changeAvailabilityStatusApi,
  deletePersonnelApi,
  editPersonnelApi,
  getPersonnelsApi,
  getSinglePersonnelApi,
} from "api/personnels";

// Login Redux States
import {
  ADD_PERSONNEL,
  CHANGE_AVAILABILITY_STATUS,
  DELETE_PERSONNEL,
  EDIT_PERSONNEL,
  GET_PERSONNELS,
  GET_SINGLE_PERSONNEL,
} from "./actionTypes";
import {
  addPersonnelFailure,
  addPersonnelSuccess,
  changeAvailabilityStatusFailure,
  changeAvailabilityStatusSuccess,
  deletePersonnelFailure,
  deletePersonnelSuccess,
  editPersonnelFailure,
  editPersonnelSuccess,
  getPersonnels,
  getPersonnelsFailure,
  getPersonnelsSuccess,
  getSinglePersonnelFailure,
  getSinglePersonnelSuccess,
} from "./actions";

function* getPersonnelsSaga() {
  try {
    const { data } = yield call(getPersonnelsApi);
    yield put(getPersonnelsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getPersonnelsFailure(error?.response?.data?.errors?.[0]?.msg));
  }
}

function* getSinglePersonnel({ payload }) {
  try {
    const { data } = yield call(getSinglePersonnelApi, payload);
    yield put(getSinglePersonnelSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(
      getSinglePersonnelFailure(error.response?.data?.message || error),
    );
  }
}

function* addPersonnel({ payload }) {
  try {
    const { data } = yield call(addPersonnelApi, payload.data);
    yield put(addPersonnelSuccess(data));

    yield payload.navigate("/personnels");
  } catch (error) {
    console.log(error);
    yield put(addPersonnelFailure(error.response?.data?.message || error));
  }
}

function* editPersonnel({ payload }) {
  try {
    yield call(editPersonnelApi, payload);
    yield put(editPersonnelSuccess(payload));
    yield payload.navigate("/personnels");
  } catch (error) {
    console.log(error);
    yield put(editPersonnelFailure(error?.response?.data || error));
  }
}

function* deletePersonnel({ payload }) {
  try {
    yield call(deletePersonnelApi, payload);
    yield put(deletePersonnelSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deletePersonnelFailure(error?.response?.data || error));
  }
}

function* changeAvailabilityStatusSaga({ payload }) {
  try {
    const { data, success } = yield call(changeAvailabilityStatusApi, payload);
    if (success) {
      yield put(changeAvailabilityStatusSuccess(data));
      yield payload.dispatch(getPersonnels());
    }
  } catch (error) {
    console.log(error);
    yield put(changeAvailabilityStatusFailure(error?.response?.data || error));
  }
}

export function* watchGetPersonnels() {
  yield takeEvery(GET_PERSONNELS, getPersonnelsSaga);
}

export function* watchSinglePersonnel() {
  yield takeEvery(GET_SINGLE_PERSONNEL, getSinglePersonnel);
}

export function* watchAddPersonnel() {
  yield takeEvery(ADD_PERSONNEL, addPersonnel);
}

export function* watchEditPersonnel() {
  yield takeEvery(EDIT_PERSONNEL, editPersonnel);
}

export function* watchDeletePersonnel() {
  yield takeEvery(DELETE_PERSONNEL, deletePersonnel);
}

export function* watchChangeAvailabilityStatus() {
  yield takeLatest(CHANGE_AVAILABILITY_STATUS, changeAvailabilityStatusSaga);
}

function* countriesSaga() {
  yield all([fork(watchGetPersonnels)]);
  yield all([fork(watchSinglePersonnel)]);
  yield all([fork(watchAddPersonnel)]);
  yield all([fork(watchEditPersonnel)]);
  yield all([fork(watchDeletePersonnel)]);
  yield all([fork(watchChangeAvailabilityStatus)]);
}

export default countriesSaga;
